import { createReducer } from 'typesafe-actions';
import produce from 'immer';

import * as Actions from '../actions/comnMessageAction';
import { MessageState, initMessage } from '../models/comnMessageModel';

export const messageReducer = createReducer<
  MessageState,
  Actions.ComnMessageAction
>(initMessage)
  .handleAction(Actions.IS_MESSAGE, (state, action) =>
    produce(state, draft => {
      const { messageCode, message, isHistoryBack, isRefresh } = action.payload;
      draft.messageCode = messageCode;
      draft.message = message;
      draft.isHistoryBack = isHistoryBack;
      draft.isMessage = true;
      draft.isRefresh = isRefresh;
    })
  )
  .handleAction(Actions.ISNO_MESSAGE, (state, action) =>
    produce(state, draft => {
      draft.messageCode = '';
      draft.message = '';
      // draft.isHistoryBack = false;
      draft.isMessage = false;
    })
  )

  .handleAction(Actions.IS_ERROR, (state, action) =>
    produce(state, draft => { 
      const { errorCode, errorMessage, isHistoryBack, isRefresh } =
        action.payload;
      draft.errorCode = errorCode;
      draft.errorMessage = errorMessage;
      draft.isHistoryBack = isHistoryBack;
      draft.isError = true;
      draft.isRefresh = isRefresh;
    })
  )
  .handleAction(Actions.ISNO_ERROR, (state, action) =>
    produce(state, draft => {
      // const {errorCode , errorMessage} = action.payload;
      draft.errorCode = '';
      draft.errorMessage = '';
      // draft.isHistoryBack = false;
      draft.isError = false;
    })
  );
